// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const textArea: Styleguide["textArea"] = {};

export default textArea;
